import * as React from 'react';
import { ReactElement } from 'react';

interface IProps {
  text?: string;
  status?: 'default' | 'error' | 'success';
}

const HelpText = ({ text, status }: IProps): ReactElement => (
  <div
    className={`help-text ${status === 'error' && 'text-form-status-error'}`}>
    {text}
  </div>
);

export default HelpText;
